import {
  connectionName,
  getRegionPickerConnection,
  RegionPickerConnectionState,
  RegionPickerDispatchers,
} from '@dh-io-emh/region-picker-store';
import { initializeStore } from '@seamless/store';
import { computed, nextTick, ref } from 'vue';
import { infuse } from '../ioc-config';

// null = no region picker available
// empty string = region picker available but no post code entered
const postCode = ref<string | null>(null);
const store = initializeStore();

let regionPickerConnectionDispatchers: RegionPickerDispatchers;

store.subscribe(connectionName, async (regionPickerState: RegionPickerConnectionState | null) => {
  if (regionPickerState) {
    postCode.value = regionPickerState.region;

    // force reopen region picker when no post code was entered
    nextTick(async () => {
      const { regionPicker: regionPickerConfig, shopCountry } = infuse('config');

      if (regionPickerConfig?.forceOpen && !regionPickerState.isOpen && !regionPickerState.region) {
        regionPickerConnectionDispatchers =
          regionPickerConnectionDispatchers ||
          (await getRegionPickerConnection(shopCountry.toLowerCase()).getRegisteredDispatchers());
        regionPickerConnectionDispatchers.setOpenState(true);
      }
    });
  }
});

export const usePostCode = () => {
  return {
    postCode,
    isPostCodeEmpty: computed(() => postCode.value === ''),
  };
};
